import {
  Product2ImageSchema,
  Product2Schema_,
  Product2VariantSchema_,
} from "@redotech/redo-product2-common/product2-types";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const ProductWithInventorySchema = Product2Schema_.extend({
  _id: z.string(),
  name: z.string(),
  vendor: z.string().nullish(),
  team: z.object({ _id: z.string(), name: z.string() }),
  images: z.array(Product2ImageSchema),
  status: z.enum(["ACTIVE", "DRAFT", "DELETED", "ARCHIVED"]),
  variants: z.array(Product2VariantSchema_),
  createdAt: z.date(),
  updatedAt: z.date(),
  totalQuantity: z.number().default(0),
  warehouseName: z.string().default("Unknown Warehouse"),
});

export const getWarehouseInventory = unaryRpc({
  name: "getWarehouseInventory" as const,
  input: z.object({
    location: z.string(),
    page: z.number().optional(),
    pageSize: z.number().min(1).max(500).default(20).optional(),
    search: z.string().optional(),
  }),
  output: z.object({
    products: z.array(ProductWithInventorySchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
});
